import { cn } from "../../lib/utils";
import {
  LayoutDashboard,
  Calendar,
  ShoppingCart,
  Star,
  Users,
  Settings,
  LogOut,
  ChevronLeft,
  ChevronRight,
  Scan,
  MessageCircleXIcon,
  Gift,
} from "lucide-react";
import { Link, useLocation,useNavigate } from "react-router-dom";
import logo from "../../assets/images/logo-light.png";

import { useAuth } from "../../context/AuthContext";

const menuItems = [
  {
    title: "Dashboard",
    icon: LayoutDashboard,
    href: "/admin",
    badge: null,
  },
//   {
//     title: "Events",
//     icon: Calendar,
//     href: "/admin/events",
//     badge: null,
//   },
  {
    title: "Orders",
    icon: ShoppingCart,
    href: "/admin/orders",
    badge: null,
  },
  // {
  //   title: "Guest Users",
  //   icon: Star,
  //   href: "/admin/guestusers",
  //   badge: null,
  // },
  {
    title: "Users",
    icon: Users,
    href: "/admin/users",
    badge: null,
  },
  {
    title: "Scan",
    icon: Scan,
    href: "/admin/scan",
    badge: null,
  },
  {
    title: "Email Templates",
    icon: MessageCircleXIcon,
    href: "/admin/email-templates",
    badge: null,
  },
  {
    title: "Coupons",
    icon: Gift,
    href: "/admin/coupon",
    badge: null,
  },
];

export function Sidebar({ open, collapsed, onOpenChange, onCollapsedChange }) {
  const location = useLocation();
  const pathname = location.pathname;
  const {logout}=useAuth();
  const navigate=useNavigate();

  const handleLogout = () => {
    console.log("Logging out...");
    logout();
    navigate("/");
    // Add your logout logic here
  };

  return (
    <>
      {/* Desktop Sidebar */}
      <aside
        className={cn(
          "fixed left-0 top-0 z-50 hidden h-screen border-r border-[#F4A696]/20 bg-gradient-to-b from-white to-[#FFF4F0] transition-all duration-300 lg:block",
          collapsed ? "w-16" : "w-64"
        )}
      >
        {/* Logo Area */}
        <div className="flex h-20 items-center justify-between border-b border-[#F4A696]/20 bg-white px-4">
          {!collapsed && (
            <Link to="/admin" className="flex items-center space-x-2">
              <div className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-[#F4A696] to-[#E89580]">
                <Calendar className="h-6 w-6 text-white" />
              </div>
              {/* <div className="flex flex-col">
                <span className="text-xl font-bold text-[#1B3C5C]">
                  EventHouse
                </span>
                <span className="text-xs text-[#F4A696]">Admin Panel</span>
              </div> */}
               <div className="flex flex-col">

              <img src={logo} alt="EventHouse Logo" className="h-12 w-32" />
              {/* <span className="text-xs text-[#F4A696]">Admin Panel</span> */}
               </div>
            </Link>
          )}
          {collapsed && (
            <Link
              to="/admin"
              className="mx-auto flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-[#F4A696] to-[#E89580]"
            >
              <Calendar className="h-6 w-6 text-white" />
            </Link>
          )}

          {/* Collapse Button - Desktop Only */}
          <button
            onClick={() => onCollapsedChange(!collapsed)}
            className={cn(
              "hidden rounded-lg p-1.5 text-[#F4A696] hover:bg-[#FFF4F0] transition-colors lg:flex",
              collapsed && "mx-auto mt-2"
            )}
          >
            {collapsed ? (
              <ChevronRight className="h-4 w-4" />
            ) : (
              <ChevronLeft className="h-4 w-4" />
            )}
          </button>
        </div>

        {/* Navigation Menu */}
        <div className="h-[calc(100vh-10rem)] overflow-y-auto px-3 py-6">
          <nav className="space-y-2">
            {menuItems.map((item) => {
              const Icon = item.icon;
              const isActive = pathname === item.href;

              return (
                <Link
                  key={item.href}
                  to={item.href}
                  className={cn(
                    "group flex items-center gap-3 rounded-xl px-3 py-3 text-sm font-medium transition-all duration-200",
                    isActive
                      ? "bg-gradient-to-r from-[#F4A696] to-[#E89580] text-white shadow-lg shadow-[#F4A696]/30"
                      : "text-[#1B3C5C]/70 hover:bg-[#FFF4F0] hover:text-[#F4A696]",
                    collapsed && "justify-center"
                  )}
                  title={collapsed ? item.title : undefined}
                >
                  <Icon className="h-5 w-5 flex-shrink-0" />
                  {!collapsed && (
                    <>
                      <span className="flex-1">{item.title}</span>
                      {item.badge && (
                        <span className="ml-auto rounded-full bg-gradient-to-r from-[#E89580] to-[#F4A696] px-2.5 py-0.5 text-xs font-semibold text-white shadow-sm">
                          {item.badge}
                        </span>
                      )}
                    </>
                  )}
                </Link>
              );
            })}
          </nav>
        </div>

        {/* Bottom Section */}
        {/* <div className="absolute bottom-0 left-0 right-0 border-t border-[#F4A696]/20 bg-white px-3 py-3"> */}
          {/* <Link
            to="/admin/settings"
            className={cn(
              "flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium text-[#1B3C5C]/70 transition-colors hover:bg-[#FFF4F0] hover:text-[#F4A696]",
              collapsed && "justify-center"
            )}
            title={collapsed ? "Settings" : undefined}
          >
            <Settings className="h-5 w-5 flex-shrink-0" />
            {!collapsed && <span>Settings</span>}
          </Link> */}

          {/* <button
            onClick={handleLogout}
            className={cn(
              "mt-1 flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium text-red-500 transition-colors hover:bg-red-50",
              collapsed && "justify-center"
            )}
            title={collapsed ? "Logout" : undefined}
          >
            <LogOut className="h-5 w-5 flex-shrink-0" />
            {!collapsed && <span>Logout</span>}
          </button> */}
        {/* </div> */}
      </aside>

      {/* Mobile Sidebar */}
      <aside
        className={cn(
          "fixed left-0 top-0 z-50 h-screen w-64 border-r border-[#F4A696]/20 bg-gradient-to-b from-white to-[#FFF4F0] transition-transform duration-300 lg:hidden",
          open ? "translate-x-0" : "-translate-x-full"
        )}
      >
        {/* Logo Area */}
        <div className="flex h-20 items-center justify-between border-b border-[#F4A696]/20 bg-white px-4">
          <Link to="/admin" className="flex items-center space-x-2">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-[#F4A696] to-[#E89580]">
              <Calendar className="h-6 w-6 text-white" />
            </div>
            <div className="flex flex-col">
              <span className="text-xl font-bold text-[#1B3C5C]">
                EventHouse
              </span>
              <span className="text-xs text-[#F4A696]">Admin Panel</span>
            </div>
          </Link>
        </div>

        {/* Navigation Menu */}
        <div className="h-[calc(100vh-10rem)] overflow-y-auto px-3 py-6">
          <nav className="space-y-2">
            {menuItems.map((item) => {
              const Icon = item.icon;
              const isActive = pathname === item.href;

              return (
                <Link
                  key={item.href}
                  to={item.href}
                  onClick={() => onOpenChange(false)}
                  className={cn(
                    "flex items-center gap-3 rounded-xl px-3 py-3 text-sm font-medium transition-all duration-200",
                    isActive
                      ? "bg-gradient-to-r from-[#F4A696] to-[#E89580] text-white shadow-lg shadow-[#F4A696]/30"
                      : "text-[#1B3C5C]/70 hover:bg-[#FFF4F0] hover:text-[#F4A696]"
                  )}
                >
                  <Icon className="h-5 w-5 flex-shrink-0" />
                  <span className="flex-1">{item.title}</span>
                  {item.badge && (
                    <span className="ml-auto rounded-full bg-gradient-to-r from-[#E89580] to-[#F4A696] px-2.5 py-0.5 text-xs font-semibold text-white shadow-sm">
                      {item.badge}
                    </span>
                  )}
                </Link>
              );
            })}
          </nav>
        </div>

        {/* Bottom Section */}
        <div className="absolute bottom-0 left-0 right-0 border-t border-[#F4A696]/20 bg-white px-3 py-3">
          <Link
            to="/admin/settings"
            onClick={() => onOpenChange(false)}
            className="flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium text-[#1B3C5C]/70 transition-colors hover:bg-[#FFF4F0] hover:text-[#F4A696]"
          >
            <Settings className="h-5 w-5 flex-shrink-0" />
            <span>Settings</span>
          </Link>

          <button
            onClick={handleLogout}
            className="mt-1 flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium text-red-500 transition-colors hover:bg-red-50"
          >
            <LogOut className="h-5 w-5 flex-shrink-0" />
            <span>Logout</span>
          </button>
        </div>
      </aside>
    </>
  );
}
